export default "__VITE_ASSET__Cesfe7fV__"